import { useSelector } from 'react-redux';
import MetricConversions from 'libs/MetricConversions';
import { metricsUnits as metricsUnitsSelector } from 'modules/Account/selectors';
export const useConversion = (metric)=>{
    const metricsUnits = useSelector(metricsUnitsSelector);
    const metricConversions = new MetricConversions(metricsUnits);
    return metricConversions[metric];
};
